import React, { useCallback } from "react";

import { useIntl } from "react-intl";

import SchemaField from "@mapmycustomers/shared/types/schema/SchemaField";
import { Button } from "@mapmycustomers/ui";

interface Props {
  field: SchemaField;
  onAction?: (field: SchemaField) => void;
}

const EditAction: React.FC<Props> = ({ field, onAction }) => {
  const intl = useIntl();

  const handleClick = useCallback(() => {
    onAction?.(field);
  }, [field, onAction]);

  return (
    <Button onClick={handleClick}>
      {intl.formatMessage({
        id: "settings.manageFields.grid.actions.edit",
        defaultMessage: "Edit",
        description: "Title of the Edit button in the Field Name column",
      })}
    </Button>
  );
};

export default EditAction;
